import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../Components copy/ThemeProvider/ThemeProvider";
import Header from "../pages copy/Header";
import { Outlet } from "react-router-dom";

import BackToTopButton from "../Components copy/BacktoTop/BackToTopComp";
import Footer from "../Components copy/Footer/Footer";
import { Helmet } from "react-helmet";

export default function SignUpLayout() {
  return (
    <div>
      <Helmet>
        <title>Introducer</title>
        <meta name="Introducer" content="Introducer" />
      </Helmet>
      <ThemeProvider theme={theme}>
        <Header />
        <Outlet />
        
        <BackToTopButton />
      </ThemeProvider>
    </div>
  );
}
